module.exports = __webpack_public_path__ + "static/img/banner.6fa88dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSharePrinting/banner.png
// module id = RSkd
// module chunks = 10